import { render } from "./DecorationApprovalCard.vue?vue&type=template&id=1aa539aa&scoped=true"
import script from "./DecorationApprovalCard.vue?vue&type=script&lang=js"
export * from "./DecorationApprovalCard.vue?vue&type=script&lang=js"

import "./DecorationApprovalCard.vue?vue&type=style&index=0&id=1aa539aa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa539aa"]])

export default __exports__